import {getAxiosInstance, rethrowErrorWithMessage} from '../helpers/axios-helper'
import {formatRawActivitiesForFront} from '../helpers/rawActivities-helper'

const baseUrl = process.env.BACKEND_URL

function getRawActivities() {
  return getAxiosInstance().get(`${baseUrl}/rawActivities`)
    .then(rawActivityData => {
      return formatRawActivitiesForFront(rawActivityData.data)
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function createRawActivity(rawActivity, image) {
  return getAxiosInstance().post(`${baseUrl}/rawActivities/`, {
    rawActivity: rawActivity,
    photo: image,
  })
    .then(() => {
      console.log('rawActivity created')
      return {
        isSuccess: true,
      }
    })
    .catch(err => {
      console.log(err)
      return {
        isSuccess: false,
        errors: [err.message]
      }
    })
}

function updateRawActivity(rawActivity, image) {
  const rawActivityId = rawActivity.rawActivityId

  return getAxiosInstance().put(`${baseUrl}/rawActivities/${rawActivityId}`, {
    rawActivity: rawActivity,
    photo: image,
  })
    .then(() => {
      console.log('rawActivity updated')
      return {
        isSuccess: true,
      }
    })
    .catch(err => {
      console.log(err)
      return {
        isSuccess: false,
        errors: [err.message]
      }
    })
}

function getRawActivityById(rawActivityId) {
  return getAxiosInstance().get(`${baseUrl}/rawActivities/${rawActivityId}`)
    .then(rawActivityResult => {
      return formatRawActivitiesForFront(rawActivityResult.data)
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function deleteRawActivity(rawActivityId) {
  return getAxiosInstance().delete(`${baseUrl}/rawActivities/${rawActivityId}`)
    .then((data) => data)
    .catch(err => {
      if (err.response.status === 403) {
        throw new Error(err.response.data.message)
      } else {
        throw new Error('Sorry we are unable to serve your request :(')
      }
    })
}

export default {
  getRawActivities,
  createRawActivity,
  updateRawActivity,
  getRawActivityById,
  deleteRawActivity,
}
